import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaInstagram,
} from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-white">

      {/* 🔥 Main Footer */}
      <div className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-4 gap-10">

        {/* Company */}
        <div>
          <h2 className="text-2xl font-bold text-primary-300 mb-4">
            Arviko Technology
          </h2>
          <p className="text-gray-300">
            We build modern digital products and provide training,
            internships, and career opportunities.
          </p>

          <div className="flex gap-4 mt-6 text-lg">
            <FaFacebookF className="hover:text-primary-300 cursor-pointer" />
            <FaTwitter className="hover:text-primary-300 cursor-pointer" />
            <FaLinkedinIn className="hover:text-primary-300 cursor-pointer" />
            <FaInstagram className="hover:text-primary-300 cursor-pointer" />
          </div>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="font-semibold text-lg mb-4">Quick Links</h3>
          <div className="flex flex-col gap-3 text-gray-300">
            <Link to="/">Home</Link>
            <Link to="/services">Services</Link>
            <Link to="/training">Training</Link>
            <Link to="/internship">Internship</Link>
            <Link to="/projects">Projects</Link>
            <Link to="/careers">Careers</Link>
            <Link to="/contact">Contact</Link>
          </div>
        </div>

        {/* Legal */}
        <div>
          <h3 className="font-semibold text-lg mb-4">Legal</h3>
          <div className="flex flex-col gap-3 text-gray-300">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms">Terms & Conditions</Link>
          </div>
        </div>

        {/* Contact */}
        <div>
          <h3 className="font-semibold text-lg mb-4">Contact</h3>
          <p className="text-gray-300 mb-2">📍 Erode, Tamil Nadu</p>
          <p className="text-gray-300 mb-2">📧 aravindan.dharman@gmail.com</p>
          <p className="text-gray-300 mb-4">📞 +91 82482 21211</p>
        </div>
      </div>

      {/* 🔥 Google Map */}
      <div className="max-w-7xl mx-auto px-6 pb-10">
        <div className="rounded-xl overflow-hidden shadow">
          <iframe
            title="map"
            src="https://www.google.com/maps?q=Kavundapdi%20Tamil%20Nadu&output=embed"
            className="w-full h-[300px] border-0"
            loading="lazy"
          ></iframe>
        </div>
      </div>

      {/* Bottom */}
      <div className="border-t border-primary-800 py-6 text-center text-gray-400 text-sm">
        © {new Date().getFullYear()} Arviko Technology. All rights reserved.
      </div>

    </footer>
  );
}